/**
 * ServiceAreaPicker — Phase 1.8 rewrite to use TieredAreaPicker.
 *
 * Replaces the Block 6.B.2 FilterChips ambient pattern (which surfaced
 * area_type filter chips that leaked onto the display tile per Phase
 * 1.7.2 picker-leak bug). The new TieredAreaPicker primitive is the
 * canonical progressive-disclosure shape per design plan §4.
 *
 * This thin wrapper preserves the Block 6.B.2 prop shape
 * (providerId + selected + onMutated) so callers (OrganizationDetail)
 * don't change.
 *
 * §m discipline: the previous file had inline FilterChips + tactical
 * pickerOpen state per Phase 1.7.2 (78ab590). Both removed — the
 * progressive-disclosure picker IS the architectural answer to the
 * type-filter UX, and Phase 1.7.2's tactical hide-unless-active bridge
 * is superseded.
 */

import { type ReactNode } from 'react';
import { useTenant } from '@/lib/auth';
import { TieredAreaPicker } from './TieredAreaPicker';
import type { ProviderServiceArea } from '@/lib/types';

export interface ServiceAreaPickerProps {
  providerId: string;
  selected: ProviderServiceArea[];
  onMutated: () => Promise<void>;
  /** Phase 1.11 — read-only render when false. Defaults to true. */
  canEdit?: boolean;
}

export function ServiceAreaPicker({
  providerId,
  selected,
  onMutated,
  canEdit = true,
}: ServiceAreaPickerProps): ReactNode {
  const { tenantSlug } = useTenant();
  return (
    <TieredAreaPicker
      tenantSlug={tenantSlug}
      providerId={providerId}
      selected={selected}
      onMutated={onMutated}
      canEdit={canEdit}
    />
  );
}
